import { inject, injectable } from 'inversify';
import { TYPES } from '@/engine/ioc';
import type { PapillaryIndicationController } from '@/surgeries/cardiac/TTVR/components/boxes/measurementBoxes/VariableDistanceMeasurementBox/indicationControllers/PapillaryIndication.controller.ts';
import type { LeafletsIndicationController } from '@/surgeries/cardiac/TTVR/components/boxes/measurementBoxes/VariableDistanceMeasurementBox/indicationControllers/LeafletsIndication.controller.ts';
import type { IIndicationController } from '@/components/boxes/objectBoxes/interfaces.ts';
import { TTVRPlanningEntityKind } from '@/surgeries/cardiac/TTVR/TTVRPlanningEntityKind.ts';

@injectable()
export class VariableDistanceMeasurementBoxResolver {
  private readonly _papillaryIndicationController: PapillaryIndicationController;

  private readonly _leafletIndicationController: LeafletsIndicationController;

  public constructor(
    @inject(TYPES.PapillaryIndicationController) papillaryIndicationController: PapillaryIndicationController,
    @inject(TYPES.LeafletsIndicationController) leafletIndicationController: LeafletsIndicationController
  ) {
    this._papillaryIndicationController = papillaryIndicationController;
    this._leafletIndicationController = leafletIndicationController;
  }

  public resolveVariableDistanceIndicationController(group: string): IIndicationController {
    const kind = this._getBoxKind(group);

    if (kind === undefined || !Object.values(TTVRPlanningEntityKind).includes(kind)) {
      throw new Error('Unknown variable measurement box kind');
    }

    switch (kind) {
      case TTVRPlanningEntityKind.Papillary:
        return this._papillaryIndicationController;
      case TTVRPlanningEntityKind.Leaflet:
        return this._leafletIndicationController;
      default: throw new Error('Unknown TTVRPlanningEntityKind literal');
    }
  }

  public resolveVariableDistanceBoxRecordLabel(group: string): string {
    const kind = this._getBoxKind(group);

    if (kind === undefined || !Object.values(TTVRPlanningEntityKind).includes(kind)) {
      throw new Error('Unknown variable measurement box kind');
    }

    switch (kind) {
      case TTVRPlanningEntityKind.Papillary:
        return 'Papillary';
      case TTVRPlanningEntityKind.Leaflet:
        return 'Leaflet';
      default: throw new Error('Unknown TTVRPlanningEntityKind literal');

    }
  }

  private _getBoxKind(group: string): TTVRPlanningEntityKind | undefined {
    switch (group) {
      case TTVRPlanningEntityKind.Papillary:
        return TTVRPlanningEntityKind.Papillary;
      case TTVRPlanningEntityKind.Leaflet:
        return TTVRPlanningEntityKind.Leaflet;
    }
  }
}
